import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 88px 1fr;
  grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-items: center;
    gap: ${({ theme }) => theme.spacing * 3}px;
  }
  .wrapper-avatar {
    align-items: center;
  }
`;
